<script setup lang="ts">
import type { FlexItemProps } from '/#/components/base/flex/flexItem'

const props = withDefaults(defineProps<FlexItemProps>(), {
  order: 0,
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  alignSelf: 'auto',
})
</script>

<template>
  <div class="v-flex-item">
    <slot />
  </div>
</template>

<style lang="scss">
.v-flex-item {
  order: v-bind('props.order');
  flex-grow: v-bind('props.flexGrow');
  flex-shrink: v-bind('props.flexShrink');
  flex-basis: v-bind('props.flexBasis');
  align-self: v-bind('props.alignSelf');
}
</style>
